@let table = this.table();

@let withCallWaiterMain = this.withCallWaiterMain();
@let withCallWaiterAnotherRound = this.withCallWaiterAnotherRound();
@let withCallWaiterRequestBill = this.withCallWaiterRequestBill();

@let callWaiterMain = this.callWaiterMain();
@let callWaiterAnotherRound = this.callWaiterAnotherRound();
@let callWaiterRequestBill = this.callWaiterRequestBill();

<app-page-header
  class="header"
  coreActivitySection="Header"
  coreUserActivityClickTracking="CloseServices"
  [backSwipe]="backSwipeConfig"
  [routerLink]="['/main', 'home']"
/>

<div class="table">Table {{ table?.tableName }}</div>

<div class="title">Service Centre</div>

<div class="description">
  Want your bill? Need service?<br/> Power up? It’s all here
</div>

<div class="buttons" coreActivitySection="Services">
  @if (withCallWaiterMain) {
    <button
      class="button"
      [class.active]="callWaiterMain"
      [disabled]="callWaiterAnotherRound || callWaiterRequestBill"
      [coreUserActivityClickTracking]="callWaiterService.getTrackingName('main', callWaiterMain)"
      (click)="onClickCallWaiterMain($event)"
    >
      <svg class="icon" width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.325 55.917c-4.283-1.912-7.82-4.89-10.146-8.878M37.68 5.556c4.263-1.213 8.663-.058 11.734 3.079"
              stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
        <path
          d="m10.194 21.265-.745-1.302.745 1.302Zm6.332 1.273 1.296-.756-1.296.756ZM8.14 27.331l-1.295.755 1.295-.755ZM19.563 8.57l1.296-.755-1.296.756Zm2.14 3.67-1.296.756 1.296-.756Zm5.123 11.764a1.5 1.5 0 1 0 2.592-1.511l-1.296.756-1.296.755Zm-7.316 6.628a1.5 1.5 0 1 0 2.592-1.512l-1.296.756-1.296.756Zm-8.333-17.268-1.296.755 1.296-.755Zm18.912-5.916 1.295-.756-1.295.756Zm6.419 11.008 1.296-.756-1.296.756Zm4.28 7.339.744 1.302a1.5 1.5 0 0 0 .551-2.058l-1.295.756Zm4.106-12.132-1.296.756 1.296-.756Zm6.42 11.008 1.295-.755-1.296.755ZM17.77 43.843l1.295-.756-1.296.756Zm25.33 5.092-.744-1.302.744 1.302Zm-7.715-10.252a1.5 1.5 0 1 0 2.592-1.511l-1.296.755-1.296.756ZM10.194 21.265l.744 1.302c1.76-1.006 3.613-.44 4.293.727l1.295-.756 1.296-.756c-1.683-2.887-5.502-3.46-8.373-1.82l.745 1.303Zm0 0-.745-1.302c-2.875 1.643-4.295 5.223-2.604 8.123l1.295-.755 1.296-.756c-.672-1.153-.254-3.004 1.502-4.008l-.744-1.302Zm9.369-12.693-1.296.756 2.14 3.669 1.296-.756 1.295-.755-2.14-3.67-1.295.756Zm2.14 3.67-1.296.755 6.42 11.008 1.295-.755 1.296-.756-6.42-11.008-1.295.755Zm-.897 17.635 1.296-.756-4.28-7.338-1.296.755-1.295.756 4.28 7.339 1.295-.756Zm-4.28-7.339 1.296-.756-5.35-9.173-1.295.756-1.296.755 5.35 9.174 1.295-.756ZM13.23 7.298l.744 1.303c1.761-1.006 3.613-.44 4.293.727l1.296-.756 1.296-.756c-1.684-2.887-5.503-3.46-8.373-1.82L13.23 7.3Zm0 0-.744-1.301C9.61 7.64 8.19 11.22 9.88 14.12l1.296-.755 1.296-.756c-.673-1.153-.255-3.004 1.501-4.008L13.23 7.3Zm16.859.15-1.296.756 6.42 11.009 1.295-.756 1.296-.756-6.42-11.008-1.295.756Zm6.419 11.009-1.296.756 4.28 7.338 1.296-.755 1.295-.756-4.28-7.339-1.295.756ZM23.756 6.176l.744 1.302c1.76-1.006 3.613-.44 4.293.726l1.296-.755 1.295-.756c-1.683-2.887-5.502-3.46-8.372-1.82l.744 1.303Zm0 0-.744-1.303c-2.876 1.643-4.296 5.224-2.605 8.124l1.296-.756 1.295-.755c-.672-1.154-.254-3.004 1.502-4.008l-.744-1.302Zm21.138 7.488-1.296.756 6.42 11.008 1.295-.756 1.296-.755-6.42-11.008-1.295.755Zm-6.333-1.273.744 1.303c1.761-1.007 3.613-.44 4.293.726l1.296-.756 1.296-.755c-1.684-2.887-5.503-3.46-8.373-1.82l.744 1.302Zm0 0-.744-1.302c-2.875 1.643-4.296 5.224-2.605 8.124l1.296-.756 1.296-.756c-.673-1.153-.255-3.004 1.501-4.008l-.744-1.302Zm-30.42 14.94-1.296.755L16.474 44.6l1.296-.756 1.295-.756-9.629-16.512-1.296.756ZM43.1 48.935l-.745-1.302c-8.708 4.977-19.065 2.7-23.29-4.546l-1.296.756-1.296.756c5.229 8.967 17.553 11.25 27.37 5.639l-.744-1.303Zm8.212-24.263-1.296.756c4.218 7.233 1.043 17.231-7.66 22.205l.743 1.302.745 1.303c9.822-5.614 14-17.341 8.764-26.321l-1.296.755ZM36.681 37.928l1.296-.755c-1.854-3.18-.517-7.747 3.555-10.074l-.744-1.302-.745-1.302c-5.19 2.966-7.53 9.263-4.658 14.189l1.296-.756Z"
          fill="currentColor"/>
      </svg>
      <div class="content">
        <div class="title">Need Assistance</div>
        <div class="description">
          @if (callWaiterMain) {
            A team member will be with you shortly to help. Tap to cancel.
          } @else {
            Tap to request assistance
          }
        </div>
      </div>
    </button>
  }

  @if (withCallWaiterAnotherRound) {
    <button
      class="button"
      [class.active]="callWaiterAnotherRound"
      [disabled]="callWaiterMain || callWaiterRequestBill"
      [coreUserActivityClickTracking]="callWaiterService.getTrackingName('tertiary', callWaiterAnotherRound)"
      (click)="onClickCallWaiterAnotherRound($event)"
    >
      <svg class="icon" width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M32 38.851a1.5 1.5 0 0 0-3 0h3Zm8.031 16.024a1.5 1.5 0 1 0 0-3v3Zm-19.062-3a1.5 1.5 0 0 0 0 3v-3ZM30.5 38.85H29v14.524h3V38.85h-1.5Zm9.531 14.524v-1.5h-9.53v3h9.53v-1.5Zm-9.53 0v-1.5h-9.532v3H30.5v-1.5ZM17.523 7.625v1.5h25.952v-3H17.524v1.5Zm30.768 4.816h-1.5v7.892h3v-7.892h-1.5Zm-35.584 7.892h1.5v-7.892h-3v7.892h1.5ZM30.5 38.125v-1.5c-8.997 0-16.291-7.294-16.291-16.292h-3c0 10.655 8.637 19.292 19.291 19.292v-1.5Zm17.792-17.792h-1.5c0 8.998-7.294 16.292-16.292 16.292v3c10.655 0 19.292-8.637 19.292-19.292h-1.5ZM43.476 7.625v1.5a3.316 3.316 0 0 1 3.316 3.316h3a6.316 6.316 0 0 0-6.316-6.316v1.5Zm-25.952 0v-1.5a6.316 6.316 0 0 0-6.316 6.316h3a3.316 3.316 0 0 1 3.316-3.316v-1.5Z"
          fill="currentColor"/>
        <path
          d="M13.979 22.875s5.29-2.32 8.896-2.542c6.266-.385 8.984 5.469 15.25 5.084 3.606-.222 8.896-2.542 8.896-2.542"
          stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      </svg>
      <div class="content">
        <div class="title">Another Round</div>
        <div class="description">
          @if (callWaiterAnotherRound) {
            A team member will be with you shortly to order. Tap to cancel.
          } @else {
            Tap to order another round of drinks
          }
        </div>
      </div>
    </button>
  }

  @if (withCallWaiterRequestBill) {
    <button
      class="button"
      [class.active]="callWaiterRequestBill"
      [disabled]="callWaiterMain || callWaiterAnotherRound"
      [coreUserActivityClickTracking]="callWaiterService.getTrackingName('secondary', callWaiterRequestBill)"
      (click)="onClickCallWaiterRequestBill($event)"
    >
      <svg class="icon" width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M42.586 5.083H18.414c-2.945 0-4.418 0-5.606.414-2.252.784-4.02 2.604-4.782 4.923-.401 1.222-.401 2.739-.401 5.77v35.595c0 2.18 2.504 3.338 4.087 1.89a2.404 2.404 0 0 1 3.263 0l1.228 1.123a4.212 4.212 0 0 0 5.719 0 4.212 4.212 0 0 1 5.719 0 4.212 4.212 0 0 0 5.718 0 4.212 4.212 0 0 1 5.72 0 4.212 4.212 0 0 0 5.718 0l1.228-1.124a2.404 2.404 0 0 1 3.263 0c1.584 1.45 4.087.292 4.087-1.89V16.192c0-3.032 0-4.549-.401-5.771-.762-2.32-2.53-4.14-4.782-4.923-1.188-.413-2.66-.413-5.606-.413Z"
          stroke="currentColor" stroke-width="3"/>
        <path
          d="M26.688 27.959h16.52M17.791 27.959h1.271M17.791 19.063h1.271M17.791 36.854h1.271M26.688 19.063h16.52M26.688 36.854h16.52"
          stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      </svg>
      <div class="content">
        <div class="title">Request My Bill</div>
        <div class="description">
          @if (callWaiterRequestBill) {
            Your server has been notified. Your bill is on its way. Tap to cancel.
          } @else {
            Tap to request your bill
          }
        </div>
      </div>
    </button>
  }
</div>

<div class="amenities">
  <div class="item">
    <svg class="icon" width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.333 26c0-8.171 0-12.257 2.539-14.795 2.538-2.539 6.624-2.539 14.795-2.539h3.25c8.17 0 12.256 0 14.795 2.539C42.25 13.743 42.25 17.829 42.25 26c0 8.17 0 12.256-2.538 14.795-2.539 2.538-6.624 2.538-14.795 2.538h-3.25c-8.171 0-12.257 0-14.795-2.538C4.334 38.256 4.334 34.17 4.334 26Z"
        stroke="#EAA540" stroke-width="3"/>
      <path
        d="M43.334 21.666c2.042 0 3.064 0 3.698.635.635.635.635 1.656.635 3.699s0 3.064-.635 3.699c-.634.634-1.656.634-3.698.634v-8.666Z"
        fill="#EAA540" stroke="#EAA540" stroke-width="3"/>
      <path d="M24.917 19.5 19.5 26h7.583l-5.416 6.5" stroke="#EAA540" stroke-width="3" stroke-linecap="round"
            stroke-linejoin="round"/>
    </svg>
    <div class="title">Charge Your Phone Here</div>
    <div class="description">
      This device features a wireless charging pad and universal cables on each side.
    </div>
  </div>

  @if (table && table?.wifiName) {
    <div class="item">
      <svg class="icon" width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.333 18.353c11.967-12.915 31.368-12.915 43.334 0m-36.111 7.795c7.977-8.61 20.911-8.61 28.889 0m-21.667 7.796c3.989-4.305 10.456-4.305 14.444 0"
          stroke="#EAA540" stroke-width="3" stroke-linecap="round"/>
        <circle cx="26" cy="40.805" r="1.75" fill="#EAA540" stroke="#EAA540" stroke-width="3"/>
      </svg>
      <div class="title">Connect To Wi-Fi</div>
      <div class="description">
        <div>Network name: <strong>{{ table.wifiName }}</strong></div>
        @if (table.wifiPassword) {
          <div>Password: <strong>{{ table.wifiPassword }}</strong></div>
        }
      </div>
    </div>
  }
</div>
